import History from './history'
import {Route} from 'vue-router'

export default (to: Route, from: Route) => {
  let previousLink = History.previous().path
  if (History.visitedRecently(to.fullPath)) {
    if (previousLink !== to.fullPath) {
      History.push(to.fullPath)
    } else {
      History.back()
    }
  } else {
    History.push(to.fullPath)
  }
}